<template>
<div class="chapter">
<div class="inner_page">
<p class="title">THE CUTTER<br/>INCIDENT</p>
<p class="subtitle">How America’s First Polio Vaccine<br/><br/>Led to the Growing Vaccine Crisis</p>
<p class="author">Paul A. Offit, <span class="small">M.D</span>.<br/><br/></p>
<p class="center"><span class="small">Yale University Press    New Haven and London</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02title.vue?c9f3ebc2